import React from "react";
import { Navigate, Route, Routes } from "react-router";
import ComponentUi from "../../../features/ComponentsUI";
import useAddIdsToUrl from "../../../utils/hooks/addIdsToUrl";
import useFacilityIds from "../../../utils/hooks/useFacilityIds";
import {
  ACCOUNT_ACTIVATION,
  BIRTHDAY_RESERVATION,
  CALENDAR_SALE,
  CHANGE_PASSWORD_CONFIRMATION,
  CINEMA_HALL_PAGE,
  ECARD_RECHARGE,
  EVENT_SALE,
  EXERCISE_SCHEDULE,
  FINALIZE_PAGE,
  FRAME_SALE,
  GIFT_CARD_ACTIVE,
  HOURLY_SCHEDULE,
  LIMITED_TICKET_COLOR,
  LIMITED_TICKET_GROUP,
  LIMITED_TICKET_SHAPE,
  LOGIN_PAGE,
  MAIN_APP,
  MODAL_TEST,
  MOVIE_DETAILS_PAGE,
  NEWSLETTER_CONFIRMATION,
  NEWSLETTER_FORM_WIDGET,
  NEWS_PAGE,
  PASSES_SALE,
  PURCHASE,
  PURCHASE_FAILED,
  REGISTRATION_PAGE,
  REGISTRATION_SUCCESS_PAGE,
  REMIND_PASS_PAGE,
  SALE_FOOD_PAGE,
  SALE_MOVIE_PAGE,
  THREE_STEP,
  UI_KIT,
  WELCOME_MOBILE,
} from "../../routes";
import BirthdayReservation from "../BirthdaysReservation";
import CalendarSale from "../CalendarSale";
import CardRecharge from "../eCardRecharge";
import EventSale from "../EventSale";
import FinalizePage from "../FinalizePage";
import GiftCard from "../GiftCardActive";
import LimitedTicketShapePage from "../LimitedTicket";
import LimitedTicketColorPage from "../LimitedTicket/LimitedTicketColorPage";
import LimitedTicketGroupPage from "../LimitedTicket/LimitedTicketGroupPage";
import Login from "../Login";
import useAuth from "../Login/hooks/useAuth";
import MyAccount from "../MyAccount";
import NewsPage from "../NewsPage";
import PassesPage from "../Passes";
import Registration from "../Registration";
import RegistrationSuccess from "../Registration/RegistrationSuccess";
import RemindPass from "../RemindPass";
import SaleFood from "../SaleFood/SaleFood";
import SaleMovie from "../SaleMovie";
import CinemaHall from "../SaleMovie/CinemaHall";
import MovieDetails from "../SaleMovie/MovieDetails";
import ScheduleExerise from "../ScheduleExercise";
import ModalWindow from "../ModalWindow";
import ThreeStepSale from "../ThreeStep";
import PurchaseSuccess from "../PurchaseSuccess";
import MobileFirstScreen from "../MobileFirstScreen";
import AccountActivated from "../AccountActivated";
import PurchaseFailed from "../PurchaseFailed";
import HourlySchedule from "../HourlySchedule";
import NewsletterFormWidget from "../NewsletterFormWidget";
import NewsletterConfirmation from "../NewsletterConfirmation";
import ChangePasswordForm from "../ChangePasswordForm";
import { getDefaultLink } from "../../../utils/getDefaultLink";
import { useSelector } from "react-redux";
import { State } from "../../store";

const RoutesComponent: React.FC = () => {
  useFacilityIds();
  useAddIdsToUrl();
  const { isLoggedIn } = useAuth();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const defaultLink = getDefaultLink(saleConfiguration.componentList);
  return (
    <React.Fragment>
      <Routes>
        <Route path={MAIN_APP} caseSensitive element={<Navigate to={defaultLink} />} />
        <Route path={SALE_MOVIE_PAGE} element={<SaleMovie />} />
        {/* <Route path={CompletedTasksUrl} element={<CompletedTasks />} /> */}
        <Route path={LOGIN_PAGE} element={isLoggedIn ? <MyAccount /> : <Login />} />
        <Route path={REMIND_PASS_PAGE} element={<RemindPass />} />
        <Route path={REGISTRATION_PAGE} element={<Registration />} />
        <Route path={REGISTRATION_SUCCESS_PAGE} element={<RegistrationSuccess />} />
        <Route path={MOVIE_DETAILS_PAGE} element={<MovieDetails />} />
        <Route path={CINEMA_HALL_PAGE} element={<CinemaHall />} />
        <Route path={FINALIZE_PAGE} element={<FinalizePage />} />
        <Route path={SALE_FOOD_PAGE} element={<SaleFood />} />
        <Route path={NEWS_PAGE} element={<NewsPage />} />
        <Route path={LIMITED_TICKET_COLOR} element={<LimitedTicketColorPage />} />
        <Route path={LIMITED_TICKET_GROUP} element={<LimitedTicketGroupPage />} />
        <Route path={LIMITED_TICKET_SHAPE} element={<LimitedTicketShapePage />} />
        <Route path={EVENT_SALE} element={<EventSale />} />
        <Route path={CALENDAR_SALE} element={<CalendarSale />} />
        <Route path={PASSES_SALE} element={<PassesPage />} />
        <Route path={EXERCISE_SCHEDULE} element={<ScheduleExerise />} />
        <Route path={GIFT_CARD_ACTIVE} element={<GiftCard />} />
        <Route path={BIRTHDAY_RESERVATION} element={<BirthdayReservation />} />
        <Route path={ECARD_RECHARGE} element={<CardRecharge />} />
        <Route path={THREE_STEP} element={<ThreeStepSale />} />
        <Route path={UI_KIT} element={<ComponentUi />} />
        <Route path={MODAL_TEST} element={<ModalWindow />} />
        <Route path={PURCHASE} element={<PurchaseSuccess />} />
        <Route path={PURCHASE_FAILED} element={<PurchaseFailed />} />
        <Route path={WELCOME_MOBILE} element={<MobileFirstScreen />} />
        <Route path={ACCOUNT_ACTIVATION} element={<AccountActivated />} />
        <Route path={HOURLY_SCHEDULE} element={<HourlySchedule />} />
        <Route path={NEWSLETTER_FORM_WIDGET} element={<NewsletterFormWidget />} />
        <Route path={NEWSLETTER_CONFIRMATION} element={<NewsletterConfirmation />} />
        <Route path={CHANGE_PASSWORD_CONFIRMATION} element={<ChangePasswordForm />} />
      </Routes>
    </React.Fragment>
  );
};

export default RoutesComponent;
